import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";
import { cn } from "../../lib/utils";

const WINDOW_SIZE = 15;

export function Pagination({ page, pageSize, total, onPageChange, testId = "pagination" }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = Math.min(total, (page + 1) * pageSize);

  const windowStart = Math.floor(page / WINDOW_SIZE) * WINDOW_SIZE;
  const windowEnd = Math.min(windowStart + WINDOW_SIZE, totalPages);
  const pageNumbers = [];
  for (let p = windowStart; p < windowEnd; p++) pageNumbers.push(p);

  const hasPrevWindow = windowStart > 0;
  const hasNextWindow = windowEnd < totalPages;

  return (
    <div
      className="rounded-b-md border-t border-border bg-surface px-4 py-3 text-xs text-text-muted"
      data-testid={testId}
    >
      <div className="mb-2" data-testid={`${testId}-summary`}>
        {total === 0 ? "0 results" : `Showing ${from}–${to} of ${total}`}
      </div>
      <div className="flex w-full items-stretch gap-2">
        <Button
          variant="outline" className="h-10 w-10 shrink-0" disabled={!hasPrevWindow}
          title="Previous 15 pages"
          onClick={() => onPageChange(Math.max(0, windowStart - WINDOW_SIZE))}
          data-testid={`${testId}-prev-button`}
        >
          <ChevronLeft size={18} strokeWidth={1.5} />
        </Button>
        <div className="flex flex-1 items-stretch gap-1.5">
          {pageNumbers.map((p) => (
            <Button
              key={p}
              variant={p === page ? "default" : "outline"}
              className={cn("h-10 min-w-[2.5rem] flex-1 text-sm", p === page && "font-bold")}
              onClick={() => onPageChange(p)}
              data-testid={`${testId}-page-button-${p + 1}`}
            >
              {p + 1}
            </Button>
          ))}
        </div>
        <Button
          variant="outline" className="h-10 w-10 shrink-0" disabled={!hasNextWindow}
          title="Next 15 pages"
          onClick={() => onPageChange(windowEnd)}
          data-testid={`${testId}-next-button`}
        >
          <ChevronRight size={18} strokeWidth={1.5} />
        </Button>
      </div>
    </div>
  );
}
